export var rentContractStates = {
  REQUEST: "-1",
  PRE_RESERVATION: "02",
  RESERVATION: "03",
  CHECK_OUT: "04",
  CHECK_IN: "05",
  CANCELED_1: "06",
  CANCELED_2: "22"
};
export var ruleBls = {
  ADDITIONAL_MILEAGE: "00",
  CDW: "06",
  S_CDW: "09",
  TIME_PERIOD: "10",
  DELIVERY: "16",
  EQUIPMENT: "22",
  NET_SUM_SERVICE: "25",
  MILEAGE_PACKAGE: "MP"
};
export var optionExtCodes = {
  TRANSMISSION: "GWU",
  EQUIPMENT_STR: "OPT",
  EQUIPMENT_LTR: "OPTLZM",
  COLOR: "color",
  CAROUSEL: "carousel"
};
export var calcBases = {
  ONE_TIME: "1X",
  PER_DAY: "DY",
  PER_MONTH: "MO",
  PER_KM: "KM"
};
export var dynDataValueCodes = {
  EMPLOYEE_ID: "pcdCustomerNumber",
  COST_CENTER: "pcdCostCentre"
};
export var provisioningTypes = {
  PICKUP: "PICKUP",
  DELIVERY_TO_COMPANY_ADDRESS: "DELIVERY_TO_COMPANY_ADDRESS",
  DELIVERY_TO_CUSTOM_ADDRESS: "DELIVERY_TO_CUSTOM_ADDRESS"
};